import { render, staticRenderFns } from "./AdminDepartment.vue?vue&type=template&id=711748fc&"
import script from "./AdminDepartment.vue?vue&type=script&lang=ts&"
export * from "./AdminDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports